<template>
  <div>
    <el-form label-width="200px">
      <el-form-item label="手機驗證碼：">
        <el-input style="width: 230px" v-model="captcha"></el-input>
        <span
          class="link"
          style="margin-left: 16px; color: #09f"
          v-if="!isCounting"
          @click="quickPay"
          >獲取驗證碼</span
        >
        <span
          v-if="$i18n.locale !== 'en' && isCounting"
          style="margin-left: 16px; color: #999"
          >({{ count }}s)重新获取短信</span
        >
        <div class="tips" v-if="isTipsShow">
          短信驗證碼已發送到{{ getFakeMobile }}
        </div>
      </el-form-item>
      <el-form-item>
        <div class="flexa">
          <el-button type="primary" @click="merOnlineAcqConfirm"
            >確認並支付</el-button
          >
          <div class="linkH" @click="toBankList">選擇其他支付方式</div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { fakeMobile } from "@/utils/fun";
import { Message } from "element-ui";
import { validateMixins } from "@/views/mixins/validate.js";
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
export default {
  mixins: [validateMixins],
  data() {
    return {
      captcha: "",
      count: 60,
      isCounting: false,
      isTipsShow: true,
      return_url: "",
      order_no: ""
    };
  },
  computed: {
    getFakeMobile() {
      const mobile = sessionStorage.getItem("mobile") || "";
      return mobile ? fakeMobile(mobile, 6, 2) : "";
    }
  },
  mounted() {
    this.order_no = sessionStorage.getItem("order_no");
    this.return_url =
      process.env.NODE_ENV === "production"
        ? `https://merchant.globalcash.hk/cardshop/success?order_id=${this.order_no}`
        : process.env.NODE_ENV === "test"
        ? `https://172.20.34.102/cardshop/success?order_id=${this.order_no}`
        : `https://172.20.34.222/cardshop/success?order_id=${this.order_no}`;

    const bankInfo = JSON.parse(sessionStorage.getItem("bankInfo")) || "";
    if (bankInfo) {
      this.quickPay();
    } else {
      this.getMobileBank();
    }
  },
  destroyed() {
    sessionStorage.removeItem("bankInfo");
  },
  methods: {
    async getMobileBank() {
      try {
        const res = await aPost2(api.queryUserBankCardList, {});
        if (!res) return;
        const data = res.data;
        if (data.errCode === "99999") {
          let list = data.retData.list;
          const length = list.length;
          const account = sessionStorage.getItem("bank_acc_no_show");
          // const last4Num = account.slice(account.length-4)
          const bank_code = sessionStorage.getItem("bank_iss_ins_code");
          let bankInfo = {};
          // 获取银行卡号后四位
          const behideNumber = account.substring(account.length - 4, account.length)
          list.forEach((e) => {
            if (
              e.iss_ins_code === bank_code &&
              behideNumber === e.bank_acc_no_show.substring(e.bank_acc_no_show.length - 4, e.bank_acc_no_show.length)
            ) {
              bankInfo = e;
            }
          });
          sessionStorage.setItem("bankInfo", JSON.stringify(bankInfo));
          this.quickPay();
        } else {
          Message({
            message: data.errMsg || "ERROR",
            type: "error",
            duration: 2 * 1000
          });
        }
      } catch (error) {
        console.log(error)
        Message({
          message: error.errMsg || "ERROR",
          type: "error",
          duration: 2 * 1000
        });
      }
    },
    async merOnlineAcqConfirm() {
      const res = await aPost2(api.merOnlineAcqConfirm, {
        verify_code: this.captcha
      });
      if (!res) return;
      const data = res.data;
      if (data.errCode === "99999") {
        sessionStorage.removeItem("bankInfo");
        this.$router.push({
          path: "success",
          query: { order_id: sessionStorage.getItem("order_no") }
        });
      } else {
        this.$message.error(data.errMsg);
      }
    },
    async quickPay() {
      const bankInfo = JSON.parse(sessionStorage.getItem("bankInfo"));
      this.$emit("getBankInfo", bankInfo);
      const params = {
        pay_type: "N201",
        channel_code: "ALLINPAY",
        pay_currency: sessionStorage.getItem("currency"),
        order_no: this.order_no,
        return_url: this.return_url,
        pay_bank: bankInfo.iss_ins_name,
        bank_account: bankInfo
      };
      const res = await aPost2(api.moneyIn, params);
      if (res.data.errCode === "99999") {
        this.startCounting();
        // this.$router.push({ path: "/fast-pay-bind/pay" });
      } else {
        this.$message.error(res.data.errMsg);
        // this.$notify({
        //   title: "錯誤",
        //   message: `請求過於頻繁，請稍後再試`,
        //   type: "error",
        // });
      }
    },
    toBankList() {
      this.$router.replace({
        path: "/banklist",
        query: { order_no: sessionStorage.getItem("order_no") }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.link {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  width: 130px;
  height: 40px;
  text-decoration: none;
  color: #2272c8 !important;
}
.tips {
  /* margin-left: 182px; */
  color: #999;
}
.linkH {
  font-size: 12px;
  color: #2272c8;
  cursor: pointer;
  margin-left: 4px;
}
</style>
